export default __webpack_public_path__ + "static/client-usage-04d1f70eff8bd70add76fcc9bc642514.png";